import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { RatingStarsInput } from 'site-modules/shared/components/rating-stars-input/rating-stars-input';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import {
  FIELD_DANGER_CLASS_NAMES,
  FORM_FIELD_CLASS_NAMES,
  FORM_FIELD_NAMES,
  LEGEND_STYLE,
  MAX_REVIEW_TEXT_LENGTH,
} from 'site-modules/shared/constants/write-review/write-review';

export function VehicleReview({ reviewData = null, fieldRef, validate, validationErrors = {} }) {
  const [remainingTextCharacters, setRemainingTextCharacters] = useState(MAX_REVIEW_TEXT_LENGTH);
  const { USER_RATING, TITLE, TEXT } = FORM_FIELD_NAMES;

  const onReviewTextChange = useCallback(
    (event, fieldName) => {
      validate(event, fieldName);
      setRemainingTextCharacters(MAX_REVIEW_TEXT_LENGTH - event.target.value.length);
    },
    [validate]
  );

  return (
    <div className="vehicle-review mb-1">
      <FormField
        {...FORM_FIELD_CLASS_NAMES}
        ref={fieldRef}
        tag={RatingStarsInput}
        label="Overall rating"
        name={USER_RATING}
        id={USER_RATING}
        onChange={validate}
        onBlur={validate}
        isValid={!(USER_RATING in validationErrors)}
        defaultValue={get(reviewData, 'userRating')}
        legendStyle={LEGEND_STYLE}
        fieldSetAndLegend
      />
      <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[USER_RATING]}</div>

      <FormField
        {...FORM_FIELD_CLASS_NAMES}
        ref={fieldRef}
        name={TITLE}
        id={TITLE}
        label="Review title"
        placeholder="Give your review a catchy title!"
        maxLength={50}
        onChange={validate}
        onBlur={validate}
        isValid={!(TITLE in validationErrors)}
        inputClassName="py-0_5"
        defaultValue={get(reviewData, 'title')}
      />
      <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[TITLE]}</div>

      <FormField
        {...FORM_FIELD_CLASS_NAMES}
        tag="textarea"
        rows={3}
        ref={fieldRef}
        name={TEXT}
        id={TEXT}
        label="Your review"
        placeholder="Let others know what you like and dislike based on your hands-on experience with this vehicle."
        onChange={onReviewTextChange}
        onBlur={validate}
        isValid={!(TEXT in validationErrors)}
        inputClassName="py-0_5"
        maxLength={MAX_REVIEW_TEXT_LENGTH}
        defaultValue={get(reviewData, 'text')}
      />
      <div className="field-danger-wrapper d-flex justify-content-between">
        <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[TEXT]}</div>
        <div className="small text-gray-dark pt-0_25">Character limit: {remainingTextCharacters}</div>
      </div>
    </div>
  );
}

VehicleReview.propTypes = {
  validate: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({}),
  reviewData: ConsumerReviewsEntities.ReviewData,
};
